<template lang="pug">
  div(:class="[$style.valueAddSection, getReverseClass(block)]")
    Block(:block="block.innerBlocks[0]")
    Block(:block="block.innerBlocks[1]")
    Block(:block="block.innerBlocks[2]")
</template>

<script lang="ts">
import { getBlockAttributes } from "~/utils/block"
import { VALUE_ADD_REVERSE } from "~/constants/blocks"

export default {
  name: "ValueAddSection",

  props: {
    block: {
      type: Object,
      required: true
    },
    lazy: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getBlockAttributes(block) {
      return getBlockAttributes(block)
    },
    getReverseClass(block) {
      return getBlockAttributes(block).class.includes(VALUE_ADD_REVERSE) ? "value-add-reverse" : ""
    }
  }
}
</script>

<style lang="css" module>
:global(.av-icon-table) {
  @apply mt-ds-lg;
}
.valueAddSection {
  @apply flex flex-col;
  > *:nth-child(2) {
    @apply order-3 pt-ds-md;
  }
}

@screen md {
  .valueAddSection {
    @apply grid;
    grid-template-rows: auto auto;
    grid-template-columns: 5fr 1fr 6fr;
    grid-template-areas:
      "image gap heading"
      "image gap table";

    > *:nth-child(1) {
      grid-area: heading;
    }

    > *:nth-child(2) {
      grid-area: image;
    }

    > *:nth-child(3) {
      grid-area: table;
    }

    &:global(.value-add-reverse) {
      grid-template-columns: 6fr 1fr 5fr;
      grid-template-areas:
        "heading gap image"
        "table gap image";
    }

    :global {
      .av-heading {
        @apply mb-0 text-left self-center;
      }

      .av-icon-table {
        @apply justify-start;
      }
    }
  }
}
</style>
